// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var CustomProductKey = function (x) {
    return x;
};
var CustomProduct = /* #__PURE__ */ (function () {
    function CustomProduct(value0) {
        this.value0 = value0;
    };
    CustomProduct.create = function (value0) {
        return new CustomProduct(value0);
    };
    return CustomProduct;
})();
var MenuProduct = /* #__PURE__ */ (function () {
    function MenuProduct(value0) {
        this.value0 = value0;
    };
    MenuProduct.create = function (value0) {
        return new MenuProduct(value0);
    };
    return MenuProduct;
})();
var MenuCombo = /* #__PURE__ */ (function () {
    function MenuCombo(value0) {
        this.value0 = value0;
    };
    MenuCombo.create = function (value0) {
        return new MenuCombo(value0);
    };
    return MenuCombo;
})();
var newtypeCustomProductKey_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCustomProductKey = function (dictHasField) {
    return dictHasField;
};
var eqCustomProductKey = {
    eq: function (x) {
        return function (y) {
            return x.name === y.name && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.price)(y.price) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.vatRate)(y.vatRate);
        };
    }
};
var eqProductKey = {
    eq: function (x) {
        return function (y) {
            if (x instanceof CustomProduct && y instanceof CustomProduct) {
                return Data_Eq.eq(eqCustomProductKey)(x.value0)(y.value0);
            };
            if (x instanceof MenuProduct && y instanceof MenuProduct) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_CartToOrder.eqCartProductKey)(x.value0)(y.value0);
            };
            if (x instanceof MenuCombo && y instanceof MenuCombo) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_CartToOrder.eqCartComboKey)(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var ordCustomProductKey = {
    compare: function (x) {
        return function (y) {
            var v = Data_Ord.compare(Data_Ord.ordString)(x.name)(y.name);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = Data_Ord.compare(Data_Money_Rounded.ordMoney)(x.price)(y.price);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(Data_Maybe.ordMaybe(Restaumatic_Menu_V2_Types_Taxes.ordVatRate))(x.vatRate)(y.vatRate);
        };
    },
    Eq0: function () {
        return eqCustomProductKey;
    }
};
var ordProductKey = {
    compare: function (x) {
        return function (y) {
            if (x instanceof CustomProduct && y instanceof CustomProduct) {
                return Data_Ord.compare(ordCustomProductKey)(x.value0)(y.value0);
            };
            if (x instanceof CustomProduct) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof CustomProduct) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MenuProduct && y instanceof MenuProduct) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_CartToOrder.ordCartProductKey)(x.value0)(y.value0);
            };
            if (x instanceof MenuProduct) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MenuProduct) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MenuCombo && y instanceof MenuCombo) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_CartToOrder.ordCartComboKey)(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 28, column 1 - line 28, column 31): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqProductKey;
    }
};
var genericProductKey = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new CustomProduct(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new MenuProduct(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new MenuCombo(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 23, column 1 - line 23, column 75): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CustomProduct) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof MenuProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof MenuCombo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 23, column 1 - line 23, column 75): " + [ x.constructor.name ]);
    }
};
var genericCustomProductKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCustomProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCustomProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CustomProductKey";
        }
    }))
};
var showProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showCustomProductKey))({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartProductKey))({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartComboKey))({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    }))))
};
var unscrambleDecodeCustomProductKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCustomProductKey)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeProductKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductKey)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(unscrambleDecodeCustomProductKey)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_CartToOrder.unscrambleDecodeCartProductKey)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_CartToOrder.unscrambleDecodeCartComboKey))))))(Unscramble_Generic.defaultOptions)
};
var encodeCustomProductKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCustomProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CustomProductKey";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodeProductKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCustomProductKey))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.encodeCartProductKey))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.encodeCartComboKey))))))
};
var decodeCustomProductKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCustomProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CustomProductKey";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeProductKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCustomProductKey)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.decodeCartProductKey)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.decodeCartComboKey)))(Foreign_Generic_Class.genericCountArgsArgument))))
};
export {
    CustomProduct,
    MenuProduct,
    MenuCombo,
    CustomProductKey,
    genericProductKey,
    eqProductKey,
    showProductKey,
    ordProductKey,
    encodeProductKey,
    decodeProductKey,
    unscrambleDecodeProductKey,
    genericCustomProductKey,
    eqCustomProductKey,
    showCustomProductKey,
    ordCustomProductKey,
    encodeCustomProductKey,
    decodeCustomProductKey,
    unscrambleDecodeCustomProductKey,
    hasFieldCustomProductKey,
    newtypeCustomProductKey_
};
//# sourceMappingURL=index.js.map
